import gsMp3 from '@/assets/audio/GS.mp3';
import rewardMp3 from '@/assets/audio/reward.mp3';
import kpMp3 from '@/assets/audio/KP.mp3';
import gsKpWav from '@/assets/audio/GS_KP.wav';

let hasUnlocked = false;

function makeAudioPlayer(src: string, volume: number) {
  let audio: HTMLAudioElement | null = null;

  const get = () => {
    if (typeof window === 'undefined') return null;
    if (!audio) {
      audio = new Audio(src);
      audio.preload = 'auto';
      audio.volume = volume;
    }
    return audio;
  };

  const play = () => {
    if (!hasUnlocked) return;
    const el = get();
    if (!el) return;
    el.currentTime = 0;
    el.play().catch(() => { /* Browser blocked autoplay — ignored. */ });
  };

  return { get, play };
}

const gsPlayer = makeAudioPlayer(gsMp3, 0.6);
const rewardPlayer = makeAudioPlayer(rewardMp3, 0.7);
const kpPlayer = makeAudioPlayer(kpMp3, 0.6);
const gsKpPlayer = makeAudioPlayer(gsKpWav, 0.6);

const allPlayers = [gsPlayer, rewardPlayer, kpPlayer, gsKpPlayer];

export const unlockGamificationAudio = async () => {
  if (hasUnlocked) return;
  const audioEls = allPlayers.map((p) => p.get()).filter(Boolean) as HTMLAudioElement[];
  if (audioEls.length === 0) return;

  try {
    await Promise.all(
      audioEls.map(async (audio) => {
        const origVolume = audio.volume;
        audio.load();
        audio.muted = true;
        audio.volume = 0;
        await audio.play();
        audio.pause();
        audio.currentTime = 0;
        audio.muted = false;
        audio.volume = origVolume;
      })
    );
    hasUnlocked = true;
  } catch {
    // Will retry on next call (hasUnlocked remains false).
  }
};

export const playGsIncreaseSound = gsPlayer.play;
export const playGsRewardSound = rewardPlayer.play;
export const playKpIncreaseSound = kpPlayer.play;
export const playGsKpCombinedSound = gsKpPlayer.play;
